<section>
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
    <a href="#" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
      <img src="../../../assets/img/logo_black.png" class="h-16 w-auto" alt="Logo" />
    </a>

    <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
      <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
        <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
          {{ 'LOGIN.SIGN_IN_PROMPT' | translate }}
        </h1>

        <div class="flex items-center justify-between">
          <button
            mat-flat-button
            color="accent"
            (click)="onLogin()"
            type="submit"
            class="w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          >
            {{ 'LOGIN.SIGN_IN' | translate }}
          </button>
        </div>

        <div
          *ngIf="loginError"
          class="mt-2 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800 dark:border-red-800 dark:bg-red-900/30 dark:text-red-200"
          role="alert">
          {{ loginError }}
        </div>

        <!-- Registrierungsseite -->
        <div class="text-sm font-medium text-gray-500 dark:text-gray-300 text-center mt-4">
           <a [href]="registrationUrl" class="text-blue-700 hover:underline dark:text-blue-500">
             {{ 'REGISTER.REGISTER_ORGANISATION' | translate }}
           </a>
        </div>

      </div>
    </div>

    <!-- Impressum-Link unten auf der Seite -->
    <div class="block mt-4">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        <a
          routerLink="/impressum"
          class="hover:underline text-blue-600 dark:text-blue-400"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'PAGES.IMPRESSUM' | translate }}
        </a>
      </p>
    </div>

    <div class="flex flex-col sm:flex-row sm:gap-1 gap-6 mt-8 border-t-2 border-gray-400 border-opacity-10 pt-4">
      <a href="https://apps.apple.com/de/app/docuty/id6752243668" target="_blank">
        <div class="flex flex-col items-center gap-5">
          <img src="../../../assets/img/appstore-badge.svg" alt="App Store" class="h-16">
          <img src="../../../assets/img/apple-qr.png" alt="App Store QR" class="w-36">
        </div>
      </a>

      <a href="https://play.google.com/store/apps/details?id=de.docuty.docutyapp" target="_blank">
        <div class="flex flex-col items-center gap-5">
          <img src="../../../assets/img/google-play-badge-cropped.png" alt="Google Play" class="h-16">
          <img src="../../../assets/img/android-qr.png" alt="Google Play QR" class="w-36">
        </div>
      </a>
    </div>
  </div>
</section>
